import { create } from "zustand";
export const useFormStore = create()((set) => ({
    editingSection: null,
    hasChanges: false,
    pendingSection: null,
    resetFunction: null,
    isBlockingModalOpen: false,
    shouldSave: null,
    setEditingSection: (section) => set({ editingSection: section }),
    setHasChanges: (hasChanges) => set({ hasChanges }),
    setBlockingModalOpen: (isOpen) => set({ isBlockingModalOpen: isOpen }),
    setPendingSection: (section) => set({ pendingSection: section }),
    setResetFunction: (fn) => set({ resetFunction: fn }),
    setShouldSave: (section) => set({ shouldSave: section }),
}));
//# sourceMappingURL=formStore.js.map